import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { AdvancedMarker as h } from "@vis.gl/react-google-maps";
import { ChargingIcon as f } from "../charging-icon/charging-icon.js";
import e from "./map-marker-wrapper.module.less.js";
import { useCallback as g } from "react";
import { MapMarker as v } from "../map-marker/map-marker.js";
const u = ({
  position: l,
  title: n,
  hasElectricalCharging: o,
  stationCode: i,
  markerType: p,
  isSelected: t,
  withoutAdvancedMarker: c,
  onClickMarker: a
}) => {
  const m = g(() => a && a(i), [a, i]), s = /* @__PURE__ */ d("div", { className: e.wrapper, children: [
    o && /* @__PURE__ */ r("div", { className: e.chargingIconWrapper, children: /* @__PURE__ */ r(f, {}) }),
    /* @__PURE__ */ r("div", { className: [e.selectedMarkerWrapper, t ? e.visible : ""].join(" "), children: /* @__PURE__ */ r("svg", { width: "40", height: "44", viewBox: "0 0 40 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ r(
      "path",
      {
        d: "M17.7899 41.0295L17.8328 41.0783L17.8787 41.1242C19.0503 42.2958 20.9497 42.2958 22.1213 41.1242L22.1672 41.0783L22.2101 41.0295L24.8698 38H32C35.3137 38 38 35.3137 38 32V8C38 4.68629 35.3137 2 32 2H8C4.68629 2 2 4.68629 2 8V32C2 35.3137 4.68629 38 8 38H15.1302L17.7899 41.0295Z",
        stroke: "black",
        strokeWidth: "2"
      }
    ) }) }),
    /* @__PURE__ */ r(v, { markerType: p })
  ] });
  return c ? s : /* @__PURE__ */ r(h, { title: n, onClick: m, position: l, children: s }, i);
};
export {
  u as MapMarkerWrapper,
  u as default
};
